import { addToChainAfter, ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import { AddCartLinesApiParameter } from "@insite/client-framework/Services/CartService";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/OrderUpload/Handlers/AddCartLineCollectionFromProducts";
import { CartLineCollectionModel, CartLineModel, ProductDto } from "@insite/client-framework/Types/ApiModels";
import { MGBW_SELECTIONS_INPUT } from "@tSurya/Common/MgbwPropertyKeys";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        products: ProductDto[];
        onSuccess?: () => void;
    },
    AddCartLinesApiParameter,
    CartLineCollectionModel
>;

type ProductWithProperties = ProductDto & {
    properties?: Record<string, string>;
};

type CartLineWithProperties = CartLineModel & {
    properties?: Record<string, string>;
};

export const PopulateMgbwSelectionsAdditionalProperties: HandlerType = props => {
    const cartLines = props.apiParameter?.cartLineCollection?.cartLines;
    if (!cartLines?.length || !props.parameter.products?.length) {
        return;
    }

    for (let index = 0; index < cartLines.length; index++) {
        const product = props.parameter.products[index] as ProductWithProperties | undefined;
        const selectionsInput = product?.properties?.[MGBW_SELECTIONS_INPUT];
        if (!selectionsInput) {
            continue;
        }

        const line = cartLines[index] as CartLineWithProperties;
        line.properties = {
            ...(line.properties || {}),
            [MGBW_SELECTIONS_INPUT]: selectionsInput,
        };
    }
};

addToChainAfter(chain, PopulateApiParameter, PopulateMgbwSelectionsAdditionalProperties);
